import { render, staticRenderFns } from "./PermissionsForm.vue?vue&type=template&id=2d562a78"
import script from "./PermissionsForm.vue?vue&type=script&lang=js"
export * from "./PermissionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports